interface AnimationDeclaration {
  setupInitialStyles: (styleDecl: CSSStyleDeclaration) => void;
  startAnimation: (styleDecl: CSSStyleDeclaration, cb?: () => void) => void;
}

const ENTER_SLIDEUP_FADEIN_ANIMATION_DURATION = 800;
const ENTER_SLIDEUP_FADEIN_ANIMATION_TIMING_FUNCTION =
  'cubic-bezier(0.22, 0.85, 0.25, 1)';

export const enterSlideUpFadeIn: AnimationDeclaration = {
  setupInitialStyles: (styleDecl: CSSStyleDeclaration) => {
    const opacityTransition = `opacity ${ENTER_SLIDEUP_FADEIN_ANIMATION_DURATION}ms ${ENTER_SLIDEUP_FADEIN_ANIMATION_TIMING_FUNCTION} 300ms`;

    const slideTransition = `transform ${ENTER_SLIDEUP_FADEIN_ANIMATION_DURATION}ms ${ENTER_SLIDEUP_FADEIN_ANIMATION_TIMING_FUNCTION}`;

    styleDecl.opacity = '0';
    styleDecl.transform = 'translateY(100%)';
    styleDecl.transition = `${opacityTransition}, ${slideTransition}`;
  },

  startAnimation: (styleDecl: CSSStyleDeclaration) => {
    window.requestAnimationFrame(() => {
      styleDecl.opacity = '1';
      styleDecl.transform = 'translateY(0px)';
    });
  },
};

const EXIT_FADEOUT_ANIMATION_DURATION = 300;
const EXIT_FADEOUT_ANIMATION_TIMING_FUNCTION = 'ease-out';

export const exitFadeOut: AnimationDeclaration = {
  setupInitialStyles: (styleDecl: CSSStyleDeclaration) => {
    styleDecl.transition = `opacity ${EXIT_FADEOUT_ANIMATION_DURATION}ms ${EXIT_FADEOUT_ANIMATION_TIMING_FUNCTION}`;
    styleDecl.opacity = '1';
    styleDecl.pointerEvents = 'none';
  },

  startAnimation: (styleDecl: CSSStyleDeclaration, cb) => {
    window.requestAnimationFrame(() => {
      styleDecl.opacity = '0';
      setTimeout(() => {
        cb?.();
      }, EXIT_FADEOUT_ANIMATION_DURATION);
    });
  },
};
